import {Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../../store";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {StudentAuthService} from "../../../services/student-auth.service";
import {SchoolClassData} from "../../../interfaces/school-class-data";
import {LargeMessageTheme} from "../../../enums/large-message-theme";
import {LargeMessageService} from "../../../services/large-message.service";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-header-organization-data',
  templateUrl: './header-organization-data.component.html',
  styleUrls: ['./header-organization-data.component.scss']
})
export class HeaderOrganizationDataComponent implements OnInit {

  data?: SchoolClassData;
  constructor(
    private studentAuthService: StudentAuthService,
    private largeMessageService: LargeMessageService
  ) {
  }

  ngOnInit() {
    this.studentAuthService.onLogInStateChanged().pipe(untilDestroyed(this)).subscribe((data) => {
      if(data) {
        //console.log(data);
        this.data = this.studentAuthService.getClassData();
      }
    })
  }
}
